import React, { useRef, useState } from 'react';
import useOnClickOutside from '@hooks/useOnClickOutside';

import './Popover.scss';

interface Props {
    content: any;
    controller?: any;
    controllerProps?: any;
    className?: string;
    id: string;
    horizontal?: 'left' | 'right';
    offsetTop?: number;
}

const Popover: React.FC<Props> = ({
    id,
    content,
    className = '',
    controller: Controller,
    controllerProps = {},
    horizontal = 'left',
    offsetTop = 0,
}) => {
    const popoverRef = useRef<HTMLDivElement>(null);
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => setIsOpen(!isOpen);

    useOnClickOutside(() => isOpen && setIsOpen(false), popoverRef);

    return (
        <div
            className={`Popover ${className} ${isOpen ? 'is-open' : ''}`}
            id={id}
            ref={popoverRef}
        >
            <Controller
                className="Popover--label"
                onClick={toggleOpen}
                {...controllerProps}
            />
            <div
                className={`Popover--list horizontal-${horizontal}`}
                style={{ top: offsetTop + 'px' }}
            >
                {content}
            </div>
        </div>
    );
};

export default Popover;
